import React from "react";
import {
    TransactionType
} from "../UIHelpers";

export const TransactionTypeColumnFormatter = (cellContent, row) => (
    TransactionType[row.transactionType]
);
